import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from "./services/auth-guard.service";
import { OverviewSurveyCampaignsContainer } from '@prikverwerker/containers/overview-survey-campaigns/overview-survey-campaigns.container';

export const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuard],
        loadChildren: () =>
            import('../modules/prikverwerker/prikverwerker.module').then(m => m.PrikverwerkerModule)
    },
    {
        path: 'upload',
        loadChildren: () =>
            import('../modules/upload/upload.module').then(m => m.UploadModule)
    },
    {
        path: 'mapviewer',
        loadChildren: () =>
            import('../modules/mapviewer/mapviewer.module').then(m => m.MapviewerModule)
    },
    {
        path: '**',
        component: OverviewSurveyCampaignsContainer
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
    exports: [RouterModule]
})

export class AppRoutingModule { }
